import React, { useEffect, useState, useRef } from 'react'
import styles from './Socialspage.module.css'
import YouttubeCard from '../../components/YouttubeCard/YouttubeCard'

import profile1 from '../../assets/profile1.svg'
import profile2 from '../../assets/profile2.svg'
import profile3 from '../../assets/profile3.svg'
import profile4 from '../../assets/profile4.svg'
import TedxSection from '../../components/TedxSection/TedxSection'

import { fetchChannelStats } from '../../utils/youtubeUtils'
import {
  getCachedYoutubeData,
  saveYoutubeData,
  getCachedInstagramData,
  saveInstagramData
} from '../../utils/firebaseUtils'

import { fetchInstagramStats } from '../../utils/instagramUtils'

// --- Reusable Scroll Reveal Hook ---
const useScrollReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animateIn);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return ref;
};

const Socialspage = () => {

  const CHANNELS = {
    faisal: 'UCPF4bAZimS4T8w1TlbeIAYg',
    vlogs: 'UCVl8DzZyGPcSM4dsF37oPgA',
    nurain: 'UCx3bUKiMw4wgcOvz0SHXPIg',
  }

  const [ytStats, setYtStats] = useState({})
  const [instagramStats, setInstagramStats] = useState(null)

  // Animation Refs
  const heroRef = useScrollReveal();
  const title1Ref = useScrollReveal();
  const cardsRef = useScrollReveal();
  const title2Ref = useScrollReveal();

  useEffect(() => {
    const loadChannelStats = async () => {
      const result = {}
      for (const key in CHANNELS) {
        const channelId = CHANNELS[key]

        // 1. Check YouTube cache
        const cached = await getCachedYoutubeData(channelId)
        if (cached) {
          result[key] = cached
          continue
        }

        // 2. Fetch fresh YouTube data
        const fresh = await fetchChannelStats(channelId)
        if (!fresh) continue

        // 3. Save to Firestore
        await saveYoutubeData(channelId, fresh)
        result[key] = fresh
      }
      setYtStats(result)
    }

    const loadInstagramStats = async () => {
      try {
        // 1. Check Instagram cache
        const cached = await getCachedInstagramData('fasbeam')
        if (cached) {
          setInstagramStats(cached)
          return
        }

        // 2. Fetch fresh Instagram data
        const fresh = await fetchInstagramStats('fasbeam')
        if (!fresh) return

        // 3. Save to Firestore
        await saveInstagramData('fasbeam', fresh)
        setInstagramStats(fresh)

      } catch (error) {
        console.error('Could not fetch Instagram stats:', error)
      }
    }

    loadChannelStats()
    loadInstagramStats()
  }, [])

  const formatSubs = (num) => {
    if (num === null || num === undefined || num === '') return '--'
    const number = Number(num)
    if (number >= 1e9) return `${(number / 1e9).toFixed(1)}B`
    if (number >= 1e6) return `${(number / 1e6).toFixed(2)}M`
    if (number >= 1e3) return `${(number / 1e3).toFixed(0)}K`
    return number
  }

  const formatVideos = (num) => {
    if (num === null || num === undefined || num === '') return '--'
    const number = Number(num)
    if (number >= 1e3) return `${(number / 1e3).toFixed(1)}K`
    return number
  }

  return (
    <div className={styles.main}>

      <div ref={heroRef} className={`${styles.hero} ${styles.revealScale}`}>
        <div className={styles.heroSpan1}>
          Join the Fas<span className={styles.bgPrimary}>Beam</span> Community of
        </div>
        <div className={styles.heroSpan2}>
          3 Million+
        </div>
        <div className={styles.heroSpan1}>
          Auto Enthusiasts
        </div>
      </div>

      <div ref={title1Ref} className={`${styles.title} ${styles.revealUp}`}>
        <span className={styles.titleText}>
          Connect With Us
        </span>
        <span className={styles.titleInfo}>
          Be a part of the FasBeam family.
        </span>
      </div>

      <div ref={cardsRef} className={`${styles.socialContainer} ${styles.revealUp}`}>
        <div className={styles.cardWrapper}>
          <YouttubeCard
            profile={profile1}
            name="Faisal Khan"
            info1={`@FasBeam • ${ytStats.faisal ? formatSubs(ytStats.faisal.subscribers) : '--'} subscribers • ${ytStats.faisal ? formatVideos(ytStats.faisal.videoCount) : '--'} videos`}
            info2="My name is Faisal Khan and I am the founder of MotorBeam..."
            link="https://www.youtube.com/@FasBeam"
          />
        </div>

        <div className={styles.cardWrapper}>
          <YouttubeCard
            profile={profile2}
            name="Faisal Khan Vlogs"
            info1={`@FasBeamVlogs • ${ytStats.vlogs ? formatSubs(ytStats.vlogs.subscribers) : '--'} subscribers • ${ytStats.vlogs ? formatVideos(ytStats.vlogs.videoCount) : '--'} videos`}
            info2="My name is Faisal Khan and I am a car enthusiast, this is my second channel for lifestyle vlogs, in Hindi."
            link="https://www.youtube.com/@FasBeamVlogs"
          />
        </div>

        <div className={styles.cardWrapper}>
          <YouttubeCard
            profile={profile3}
            name="Nurain Khan"
            info1={`@NurainFaisalKhan • ${ytStats.nurain ? formatSubs(ytStats.nurain.subscribers) : '--'} subscribers • ${ytStats.nurain ? formatVideos(ytStats.nurain.videoCount) : '--'} videos`}
            info2="I am a Full time Senior Software Consultant, a crazy traveller and an automobile enthusiast who loves to both drive cars and ride motorcycles."
            link="https://www.youtube.com/c/nurainfaisalkhan"
          />
        </div>

        <div className={styles.cardWrapper}>
          <YouttubeCard
            profile={profile4}
            isInsta={true}
            name="fasbeam"
            info1={`${instagramStats?.posts ? `${formatVideos(instagramStats.posts)} Posts` : '-- Posts'} • ${instagramStats?.followers ? `${formatSubs(instagramStats.followers)} Followers` : '-- Followers'} • ${instagramStats?.following ? `${formatSubs(instagramStats.following)} Following` : '-- Following'}`}
            info2="💻 Founder MotorBeam, CarAdvice, FK-R 🎥 2.2 million On YT 😍 Car Nut, Army Brat more..."
            link="https://www.instagram.com/fasbeam/"
          />
        </div>
      </div>

      <div ref={title2Ref} className={`${styles.title} ${styles.revealUp}`}>
        <span className={styles.titleText}>
          TEDx Talks by Faisal
        </span>
      </div>

      <TedxSection />

    </div>
  )
}

export default Socialspage